/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import Alerts from 'app/scripts/views/lib/alerts';
import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
import { Auth } from 'app/scripts/db/auth';
import { CustomStickerSelectionView } from 'app/scripts/views/stickers/CustomStickerSelectionView';
import DragSort from 'app/scripts/views/lib/drag-sort';
import { ModelLoader } from 'app/scripts/db/model-loader';
import BluebirdPromise from 'bluebird';
import { Sticker } from 'app/scripts/models/Sticker';
import { Stickers } from 'app/scripts/data/stickers';
import { StickerSelectionView } from 'app/scripts/views/stickers/StickerSelectionView';
import { Util } from 'app/scripts/lib/util';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { View } from 'app/scripts/views/internal/view';
import { templates } from 'app/scripts/views/internal/templates';
import { l } from 'app/scripts/lib/localize';
import { dontUpsell, isChrome } from '@trello/browser';
import productPromoDisableOverlay from 'app/scripts/views/templates/product_promo_disable_overlay';
import stickerSelect from 'app/scripts/views/templates/sticker_select';
import {
  getGiphyApi,
  giphyStickersToTrelloStickers,
  mapTrelloLocaleToGiphyLocale,
} from '@trello/giphy';
import { getKey, Key } from '@trello/keybindings';
import { MemberState } from 'app/scripts/view-models/member-state';
import { currentLocale } from '@trello/locale';

class StickerPickerView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'stickers';
    this.prototype.viewIcon = 'sticker';
    this.prototype.className = 'board-menu-content-frame';

    this.prototype.events = {
      'keyup .js-search-stickers': 'onQueryChange',
      'change .js-upload-image': 'setUploadImage',
      'change .js-use-animated-stickers': 'onAnimationPreferenceChange',
    };
  }

  initialize() {
    let left;
    this.me = Auth.me();
    const org = (left = this.model.getOrganization()) != null ? left : null;

    if (
      this.me.hasPremiumFeature('additionalStickers') ||
      org?.hasPremiumFeature('additionalStickers') ||
      false
    ) {
      ModelLoader.loadMemberCustomStickers(this.me.id).done();
    }

    this.listenTo(
      this.me.customStickerList,
      'change add remove reset',
      this.renderCustomStickers,
    );

    return (this.searchForStickerDebounced = _.debounce(
      this.searchForSticker,
      1000,
    ));
  }

  render() {
    let left;
    this.$el.empty();
    const org = (left = this.model.getOrganization()) != null ? left : null;
    const data = this.model.toJSON();
    data.additionalStickersEnabled =
      this.me.hasPremiumFeature('additionalStickers') ||
      org?.hasPremiumFeature('additionalStickers') ||
      false;
    data.upsellEnabled = !dontUpsell();
    data.useAnimatedStickers = MemberState.getUseAnimatedStickers();

    this.$el.html(stickerSelect(data));

    this.renderStandardStickers();
    this.renderPremiumStickers();
    this.renderCustomStickers();

    this.defer(() => DragSort.refreshDraggableStickers());

    return this;
  }

  _getStickers(pack) {
    const { premium } = Stickers[pack];
    return Stickers[pack].stickers.map(
      (data) =>
        new Sticker(_.extend({ premium }, data), {
          modelCache: this.modelCache,
        }),
    );
  }

  _loadStickers($stickerList) {
    const loadingClass = 'sticker-list-loading';
    $stickerList.addClass(loadingClass);

    const imgs = $stickerList.find('.sticker-select-image').get();
    const imgLoads = imgs.map(function (img) {
      const $img = $(img);
      return new BluebirdPromise(function (resolve) {
        $img.on('load', resolve);
        return $img.on('error', resolve);
      });
    });

    return BluebirdPromise.all(imgLoads)
      .then(() => $stickerList.removeClass(loadingClass))
      .done();
  }

  renderStandardStickers() {
    const $standardStickers = this.$('.js-standard-sticker-list');

    const stickerViews = this._getStickers('standard').map((sticker) => {
      return this.subview(StickerSelectionView, sticker);
    });

    this.appendSubviews(stickerViews, $standardStickers);

    this._loadStickers($standardStickers);

    return this;
  }

  renderPremiumStickers() {
    let left;
    const org = (left = this.model.getOrganization()) != null ? left : null;
    const $parent = this.$('.js-premium-stickers');
    const enabled =
      this.me.hasPremiumFeature('additionalStickers') ||
      org?.hasPremiumFeature('additionalStickers') ||
      false;

    for (const pack in Stickers) {
      const { premium } = Stickers[pack];
      if (premium) {
        const $stickerPack = $(
          templates.fill(
            require('app/scripts/views/templates/sticker_pack_selection_list'),
            { displayName: l(['sticker packs', pack]) },
          ),
        );

        const $stickerPackList = $stickerPack.filter('.js-sticker-list');

        const stickerViews = this._getStickers(pack).map((sticker) => {
          return this.subview(StickerSelectionView, sticker, { org });
        });

        this.appendSubviews(stickerViews, $stickerPackList);

        this._loadStickers($stickerPackList);

        $parent.append($stickerPack);

        if (!enabled) {
          $stickerPackList.append(productPromoDisableOverlay());
        }
      }
    }

    return this;
  }

  renderCustomStickers() {
    let left;
    const org = (left = this.model.getOrganization()) != null ? left : null;
    const $customStickerList = this.$('.js-custom-sticker-list');
    $customStickerList.children().detach();

    const hasCustomStickers =
      this.me.hasPremiumFeature('customStickers') ||
      org?.hasPremiumFeature('customStickers') ||
      false;

    if (hasCustomStickers) {
      const stickerSubviews = this.me.customStickerList.map((sticker) => {
        return this.subview(CustomStickerSelectionView, sticker, { org });
      });
      this.appendSubviews(stickerSubviews, $customStickerList);
    } else {
      $customStickerList.append(productPromoDisableOverlay());
    }
    $customStickerList.append(
      templates.fill(
        require('app/scripts/views/templates/sticker_select_item_upload'),
        { id: this.me.id },
      ),
    );

    this.defer(() => DragSort.refreshDraggableStickers());

    return this;
  }

  setUploadImage(e) {
    stopPropagationAndPreventDefault(e);
    const $file = this.$('.js-upload-image');

    if ($file.prop('files') == null && $file.val()) {
      // Yuck, it's IE.  Let's submit the form.
      Util.uploadFile(Auth.myToken(), $file, function () {});
      return;
    }

    const { files } = $file[0];
    if (files.length > 0) {
      this.uploadStickers(files);
    }
  }

  uploadStickers(files) {
    _.each(files, (file) => {
      const traceId = Analytics.startTask({
        taskName: 'create-attachment/sticker',
        source: 'boardMenuDrawerStickersScreen',
      });

      const reader = new FileReader();

      if (!Util.validFileSize(file)) {
        Analytics.taskFailed({
          taskName: 'create-attachment/sticker',
          traceId,
          source: 'boardMenuDrawerStickersScreen',
          error: new Error('file too large'),
          attributes: {
            fileSize: file.size,
            fileType: file.type,
          },
        });
        Alerts.flash('file too large', 'error', 'sticker-picker');
        return;
      }

      const fd = new FormData();
      fd.append('token', Auth.myToken());
      fd.append('file', file);
      const idOrganization = this.model?.getOrganization()?.id;
      if (idOrganization) {
        fd.append('idOrganization', idOrganization);
      }

      reader.onload = (file) => {
        const url = file.target.result;
        return this.me.customStickerList.createWithTracing(
          { url },
          {
            data: fd,
            processData: false,
            contentType: false,
            traceId,
            error: (model) => {
              model.set('error', 'Failed');
              return this.setTimeout(() => model.destroy(), 5000);
            },
          },
          tracingCallback(
            {
              taskName: 'create-attachment/sticker',
              traceId,
              source: 'boardMenuDrawerStickersScreen',
              attributes: {
                fileSize: file.size,
                fileType: file.type,
              },
            },
            (_err, sticker) => {
              const board = this.model;
              if (sticker && board) {
                Analytics.sendTrackEvent({
                  action: 'uploaded',
                  actionSubject: 'stickerAttachment',
                  source: 'boardMenuDrawerStickersScreen',
                  attributes: {
                    taskId: traceId,
                    fileSize: file.size,
                    fileType: file.type,
                  },
                  containers: {
                    board: { id: board.id },
                    organization: { id: board.getOrganization()?.id },
                    enterprise: { id: board.getEnterprise()?.id },
                  },
                });
              }
            },
          ),
        );
      };

      return reader.readAsDataURL(file);
    });
  }

  onAnimationPreferenceChange(e) {
    stopPropagationAndPreventDefault(e);
    return MemberState.setUseAnimatedStickers(e.target.checked);
  }

  onQueryChange(e) {
    stopPropagationAndPreventDefault(e);

    const key = getKey(e);
    if ([Key.Enter, Key.Escape].includes(key)) {
      return;
    }

    const query = e.target.value;

    if (this.currentQuery !== query) {
      this.showSearchSpinner();
    }

    this.currentQuery = query;
    if (!(query != null ? query.length : undefined)) {
      this.showStaticStickers();
      return;
    }

    return this.searchForStickerDebounced(query);
  }

  searchForSticker(query) {
    if (query != null ? query.length : undefined) {
      return getGiphyApi()
        .search(query, {
          limit: 48,
          rating: 'g',
          lang: mapTrelloLocaleToGiphyLocale(currentLocale),
          type: 'stickers',
        })
        .then((results) => {
          // In case a previous search completes after the latest search.
          if (query === this.currentQuery) {
            const stickers = giphyStickersToTrelloStickers(
              results.data,
              isChrome(),
            );
            return this.renderStickerSearchResults(stickers);
          }
        })
        .catch(() => {
          // For now just say that there are no results.
          return this.renderStickerSearchResults([]);
        });
    }
  }

  renderStickerSearchResults(results) {
    let left;
    this.$('.js-giphy-stickers-no-results').toggleClass(
      'hide',
      results.length !== 0,
    );

    const org = (left = this.model.getOrganization()) != null ? left : null;
    const stickerViews = results.map((data) => {
      const sticker = new Sticker(
        _.extend({ isGiphySticker: true, image: data.url }, data),
        { modelCache: this.modelCache },
      );
      return this.subview(StickerSelectionView, sticker, { org });
    });

    this.ensureSubviews(stickerViews, this.$('.js-search-sticker-list'));

    this.showSearchResults();

    this.defer(() => DragSort.refreshDraggableStickers());

    return this;
  }

  showSearchSpinner() {
    this.hideStaticStickers();
    this.hideSearchResults();
    return this.$('.js-search-spinner').removeClass('hide');
  }

  showStaticStickers() {
    this.hideSearchSpinner();
    this.hideSearchResults();
    return this.$('.js-static-stickers').removeClass('hide');
  }

  showSearchResults() {
    this.hideSearchSpinner();
    this.hideStaticStickers();
    return this.$('.js-giphy-stickers').removeClass('hide');
  }

  hideStaticStickers() {
    return this.$('.js-static-stickers').addClass('hide');
  }

  hideSearchSpinner() {
    return this.$('.js-search-spinner').addClass('hide');
  }

  hideSearchResults() {
    return this.$('.js-giphy-stickers').addClass('hide');
  }
}

StickerPickerView.initClass();
export { StickerPickerView };
